/* PAYROLLS */
export const VALIDATE_PAYROLLS = 'VALIDATE_PAYROLLS';
export const VALIDATE_PAYROLLS_SUCCESS = 'VALIDATE_PAYROLLS_SUCCESS';
export const VALIDATE_PAYROLLS_FAILED = 'VALIDATE_PAYROLLS_FAILED';
export const INTEGRATE_PAYROLLS = 'INTEGRATE_PAYROLLS';
export const INTEGRATE_PAYROLLS_SUCCESS = 'INTEGRATE_PAYROLLS_SUCCESS';
export const INTEGRATE_PAYROLLS_FAILED = 'INTEGRATE_PAYROLLS_FAILED';
export const NOTIFY_PAYROLLS = 'NOTIFY_PAYROLLS';
export const NOTIFY_PAYROLLS_SUCCESS = 'NOTIFY_PAYROLLS_SUCCESS';
export const NOTIFY_PAYROLLS_FAILED = 'NOTIFY_PAYROLLS_FAILED';